module.exports = __webpack_public_path__ + "img/standrews.80a3546.png";